<div class="json-editor">
  <div 
    class="json-form" 
    [style.width]="!showPreview ? '100%' : '50%'" 
    [style.margin]="!showPreview ? '0 20%' : '0'">
    <input 
      type="text" 
      class="object-name" 
      placeholder="Object Name" 
      (keyup)="removeWhitespace()" 
      [(ngModel)]="objectName" 
      [disabled]="disableObjectName"/>

    <!-- <app-core-engine-field *ngFor="let item of jsonPairs; let i = index; trackBy:trackByFn" (pair)="handlePairOutput($event, jsonPairs, i);" [initialPairValue]="item">

  </app-core-engine-field> -->

    <ng-template #recursiveList let-jsonEditorFields>
      <div
        *ngFor="let item of jsonEditorFields; let i = index; trackBy: trackByFn"
        style="margin-top:15px;"
      >
        <app-core-engine-field
          *ngIf="showTopKeyValues === 0 || i < showTopKeyValues || showAllKeyValues"
          (pair)="handlePairOutput($event, jsonEditorFields, i)"
          [initialPairValue]="item"
          (delete)="deleteItem(jsonEditorFields, i)"
          [showPreview]="showPreview"
        >
          {{ item.title }}
        </app-core-engine-field>
        <div
          style="background: white; padding: 10px; margin-left:20px; border-left: 3px solid black;"
          *ngIf="item.type == 'Object' || item.type == 'Array'"
        >
          <!-- {{ item.key + '>'}} -->
          <ng-container
            *ngTemplateOutlet="
              recursiveList;
              context: { $implicit: item.value }
            "
          ></ng-container>
          <button
            style="background: transparent"
            (click)="addNewFieldTo(item.value, item.type === 'Array')"
            [disabled]="item.disableAddKey"
          >
            + Add New Key
          </button>
        </div>
      </div>
    </ng-template>
    <ng-container
      *ngTemplateOutlet="recursiveList; context: { $implicit: jsonEditorFields }"
    ></ng-container>
    <button
      class="button-blk"
      style="margin-top: 15px; margin-bottom: 15px;"
      (click)="addNewFieldTo(jsonEditorFields, false)"
    >
      + Add New Key
    </button>
    <button
      class="button-blk"
      style="margin-top: 15px; margin-bottom: 15px; float: right;"
      *ngIf="showTopKeyValues > 0"
      (click)="showAllKeyValues = !showAllKeyValues"
    >
      {{ !showAllKeyValues ? 'Show More' : 'Show Less' }}
    </button>
  </div>
    <div [hidden]="!showPreview" id="json-format" #jsonFormat>

    </div>
</div>